import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Slide,
  TextField,
  Autocomplete,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import getClientService from "../../../../services/getClientService";
import getJournalService from "../../../../services/getJournalService";
import getUserService from "../../../../services/getUserService";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AddEdit = ({
  setOpenAddDialog,
  openAddDialog,
  selectedUser,
  setSelectedUser,
  fetchUser,
}) => {
  const theme = useTheme();
  const [journals, setJournals] = useState([]);
  const [clients, setClients] = useState([]);
  const getStyles = (name, journal) => {
    return {
      fontWeight: journal.includes(name)
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
    };
  };

  const handleClose = () => {
    fetchUser();
    setOpenAddDialog(false);
    formik.resetForm();
    setSelectedUser(null);
  };

  const isEdit = Boolean(selectedUser);
  const validationSchema = Yup.object({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    phone_num: Yup.string().required("Phone Number is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: isEdit
      ? Yup.string()
      : Yup.string().required("Password is required"),
    client: Yup.array().when("role", {
      is: 2,
      then: (schema) =>
        schema
          .min(1, "At least one client is required")
          .required("Client is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    role: Yup.number()
      .oneOf([1, 2], "Role is required")
      .required("Role is required"),
    userType: Yup.string()
      .oneOf(["user", "tl"])
      .required("User type is required"),
  });

  // Set up Formik
  const formik = useFormik({
    initialValues: {
      first_name: selectedUser?.first_name || "",
      last_name: selectedUser?.last_name || "",
      phone_num: selectedUser?.phone_num || "",
      email: selectedUser?.email || "",
      password: selectedUser?.password || "",
      journal: selectedUser?.journal
        ? Array.isArray(selectedUser?.journal)
          ? selectedUser?.journal.map((item) => item["0"])
          : JSON.parse(selectedUser?.journal)
        : [],
      client: selectedUser?.client
        ? Array.isArray(selectedUser?.client)
          ? selectedUser?.client.map((item) => item["id"] || item)
          : JSON.parse(selectedUser?.client)
        : [],
      role: selectedUser?.role || 1,
      userType:
        selectedUser?.userType || (selectedUser?.role === 2 ? "tl" : "user"),
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log("values", values);
      // Ensure userType and role are consistent
      const payload = {
        ...values,
        userType: values.role === 2 ? "tl" : "user",
        role: values.role,
      };
      if (selectedUser) {
        // Update existing journal
        try {
          let respons = await getUserService.UpdateUser(
            payload,
            selectedUser.id
          );
          handleClose();
        } catch (error) {
          console.error("Error editing category:", error);
        }
      } else {
        // Add new journal
        try {
          console.log("payload", payload);
          let respons = await getUserService.CreateUser(payload);
          handleClose();
        } catch (error) {
          console.error("Error editing category:", error);
        }
      }
    },
  });

  const fetchJournals = async () => {
    try {
      let respons = await getJournalService.GetAllJournal();
      console.log(respons);

      setJournals(respons);
    } catch (error) {
      console.error("Error editing category:", error);
    }
  };

  const fetchCleint = async () => {
    try {
      const list = await getClientService.GetClientList();
      setClients(list);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  useEffect(() => {
    fetchJournals();
    fetchCleint();
  }, []);

  const handleChangeJournals = (event, newValue) => {
    // Only store the IDs of selected journals
    formik.setFieldValue(
      "journal",
      newValue.map((journal) => journal.id)
    );
  };

  const handleChangeClients = (event, newValue) => {
    formik.setFieldValue(
      "client",
      newValue.map((client) => client.id)
    );
  };

  const handleRoleChange = (event) => {
    const value = event.target.value;
    formik.setFieldValue("role", value);
    formik.setFieldValue("userType", value === 2 ? "tl" : "user");
  };

  return (
    <React.Fragment>
      <Dialog
        open={openAddDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"sm"}
      >
        <DialogTitle className="modal_header_dealog">{"Add"} </DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <div className="row">
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="First Name"
                    name="first_name"
                    variant="outlined"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.first_name &&
                      Boolean(formik.errors.first_name)
                    }
                    helperText={
                      formik.touched.first_name && formik.errors.first_name
                    }
                  />
                </FormControl>
              </div>
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="Last Name"
                    name="last_name"
                    variant="outlined"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.last_name &&
                      Boolean(formik.errors.last_name)
                    }
                    helperText={
                      formik.touched.last_name && formik.errors.last_name
                    }
                  />
                </FormControl>
              </div>
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="Number"
                    name="phone_num"
                    variant="outlined"
                    value={formik.values.phone_num}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.phone_num &&
                      Boolean(formik.errors.phone_num)
                    }
                    helperText={
                      formik.touched.phone_num && formik.errors.phone_num
                    }
                  />
                </FormControl>
              </div>
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="Email"
                    name="email"
                    variant="outlined"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </FormControl>
              </div>

              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="Password"
                    name="password"
                    variant="outlined"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                  />
                </FormControl>
              </div>
              <div className="col-6">
                <FormControl className="mt-3 " fullWidth size="small">
                  <InputLabel id="role-label">Role</InputLabel>
                  <Select
                    labelId="role-label"
                    id="role"
                    name="role"
                    value={formik.values.role}
                    label="Role"
                    onChange={handleRoleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.role && Boolean(formik.errors.role)}
                  >
                    <MenuItem value={1}>Editor</MenuItem>
                    <MenuItem value={2}>TL</MenuItem>
                  </Select>
                  {formik.touched.role && formik.errors.role && (
                    <div
                      style={{ color: "#d32f2f", fontSize: 12, marginTop: 4 }}
                    >
                      {formik.errors.role}
                    </div>
                  )}
                </FormControl>
              </div>

              <div className="col-12 mt-3">
                <FormControl fullWidth size="small">
                  <Autocomplete
                    multiple
                    id="journal"
                    options={journals}
                    value={journals.filter((journal) =>
                      formik.values.journal.includes(journal.id)
                    )}
                    onChange={handleChangeJournals}
                    getOptionLabel={(option) => option.name}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Publication"
                        variant="outlined"
                        size="small"
                        placeholder="Search and Select publication"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </div>

              {/* Only show Clients field if TL is selected */}
              {formik.values.role === 2 && (
                <div className="col-12 mt-3">
                  <FormControl fullWidth size="small">
                    <Autocomplete
                      multiple
                      id="client"
                      options={clients}
                      value={clients.filter((client) =>
                        formik.values.client.includes(client.id)
                      )}
                      onChange={handleChangeClients}
                      getOptionLabel={(option) =>
                        option.first_name + " " + option.last_name
                      }
                      filterSelectedOptions
                      getOptionDisabled={(option) =>
                        formik.values.client.includes(option.id)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Clients"
                          variant="outlined"
                          size="small"
                          placeholder="Search and Select clients"
                          fullWidth
                          error={
                            formik.touched.client &&
                            Boolean(formik.errors.client)
                          }
                          helperText={
                            formik.touched.client && formik.errors.client
                          }
                        />
                      )}
                    />
                  </FormControl>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button color="success" variant="outlined" type="submit">
              Confirm
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default AddEdit;
